import http from '@/http/index.js' //axios 请求引入


const api = {
	statPush(param) {
		return http.post("/api/tongji/push", param); //统计
	},
	// 字典接口
	dictlist(param) {
		return http.get("/prod-api/api/common/dict/list", param); //统计
	},
	surveySubmit(param){
		return http.postjson("/prod-api/api/survey/submit",param); //提交问卷
	},
	surveyinfo(param){
		return http.get("/prod-api/api/survey/info/"+param.code,param); //查询问卷详情
	},

	login(param){
		return http.post("/prod-api/api/login",param); //获取token
	},
	getUser(param){
		return http.get("/prod-api/api/user/info",param); //获取用户信息
	},
	checklogin(param){
		return http.post("/prod-api/api/checklogin",param); //验证登录
	},
	register(param){
		return http.post("/prod-api/api/register",param); //注册
	},
	captchaImage(param){
		return http.get("/prod-api/captchaImage",param); //图片验证码
	},
	sendCode(param){
		return http.post("/prod-api/api/common/sms/sendCode",param); //验证码
	},
	updatePassword(param){
		return http.post("/prod-api/api/user/updatePassword",param); //修改密码
	},
	loginBySms(param){
		return http.post("/prod-api/api/loginBySms",param); //手机号登录
	},
	linksList(param){
		return http.get("/prod-api/api/links/list",param); //友情链接
	},
	menuList(param){
		return http.get("/prod-api/api/menu/list",param); //菜单列表
	},
	VerifyimgHua(p){
		return  http.get("/prod-api/captchaImageSlice",p);/*滑动验证 */
	},
	VerifyimgValid(p){
		return  http.post("/prod-api/captchaVerify",p);/*验证滑动结果 */
	},

	fgList(param){
		return http.get("/prod-api/api/fg/list",param); //广告内容列表
	},
	noticeList(param){
		return http.get("/prod-api/api/notice/list",param); //公告列表
	},
	noticeInfo(param){
		return http.get("/prod-api/api/notice/info",param); //公告详情
	},

	categoryList(param){
		return http.get("/prod-api/api/art/categoryList",param); //文章分类列表
	},
	artList(param){
		return http.get("/prod-api/api/art/list",param); //文章列表
	},
	artInfo(param){
		return http.get("/prod-api/api/art/info",param); //文章详情
	},

	liveList(param){
		return http.get("/prod-api/api/live/list",param); //直播列表
	},
	liveInfo(param){
		return http.get("/prod-api/api/live/info",param); //直播详情
	},
	livePassword(param){
		return http.post("/prod-api/api/live/password",param); //提交密码
	},

	//会员信息
	companyInfo(param){
		return http.get("/prod-api/api/company/info",param); //企业信息
	},
	activityList(param){
		return http.get("/prod-api/api/activity/list",param); //活动列表
	},
	contactsInfo(param){
		return http.get("/prod-api/api/company/contactsInfo",param); //理事信息
	},
	contactsInfoPost(param){
		return http.post("/prod-api/api/company/contactsInfo",param); //理事信息
	},

	allupload(param){
		return http.postform("/prod-api/api/common/upload",param); //通用上传
	},

	uploadActivityFile(param){
		return http.post("/prod-api/api/activity/uploadActivityFile",param); //上传保存到活动
	},
	activityInfo(param){
		return http.get("/prod-api/api/activity/info",param); //活动详情
	},
	companyUpdatePassword(param){
		return http.post("/prod-api/api/company/updatePassword",param); //修改密码
	},
	ruhuiBaoming(param){
		return http.post("/prod-api/api/ruhui/baoming",param); //入会报名
	},
	companyList(param){
		return http.get("/prod-api/api/company/list",param); //单位列表
	},

	zazhiList(param){
		return http.get("/prod-api/api/zazhi/list",param); //杂志列表
	},
	zazhiDingyue(param){
		return http.post("/prod-api/api/zazhi/dingyue",param); //订阅杂志
	},
	searchCompany(param){
		return http.get("/prod-api/api/company/searchCompany",param); //搜索单位
	},

}

export default api






